<template>
  <div>
    <div class="cthome" ref="homeCont">
      <HeaderInfo />
      <div class="containmain">
        <!-- <Promotion /> -->
        <!-- <hr class="x-hr-border-glow my-1" /> -->
        <marquee-text :duration="5" :paused="isMarqueePause" @mouseover="mouseOver" @mouseleave="mouseLeave">
          {{ mq_text }}
        </marquee-text>
        <Promotion />
        
        <ProviderSlide />
        <Game />
        <Boardcast />
      </div>
      <div>
          <a :href="WebSetting.lineId" class="line-blog" target="_blank">
            <img
              src="@/assets/images/contact-us.webp"
              class="line-logo"
              alt="แอดไลน์"
              width="50"
              height="70"
            />
          </a>
       </div>
    </div>
    <PromotionModal ref="promotionmodal" />
  </div>
</template>

<script>
import { HTTP } from "@/services/http-common";
import HeaderInfo from "@/components/HeaderInfo.vue";
// import Promotion from "@/components/Promotion.vue";
import ProviderSlide from "@/components/ProviderSlide.vue";
import Game from "@/components/Game.vue";
import Boardcast from "@/components/Boardcast.vue";
import Promotion from "@/components/Promotion.vue";
import { mapGetters } from "vuex";
import PromotionModal from "@/components/modal/PromotionModal.vue";
import MarqueeText from 'vue-marquee-text-component'

export default {
  name: "HomeView",
  components: {
    PromotionModal,
    HeaderInfo,
    // Promotion,
    ProviderSlide,
    Game,
    Boardcast,
    Promotion,
    MarqueeText,
  },
  data() {
    return {
      isMarqueePause :false,
      mq_text:"",
    };
  },
  metaInfo() {
    return {
      title: this.WebSetting.title,
      link: [
        {
          rel: "icon",
          href: this.WebSetting.logo,
        },
      ],
    };
  },
  mounted() {
    this.fetchWebSetting();
    this.fetchUserProfile();
    if (this.Auth.loggedIn) {
      this.fetchProvider();
      this.fetchTurnover();
      this.intervalfetchTurnover();
      this.intervalfetchUserProfile();
    }
  },
  methods: {
    fetchProvider() {
      let homeCont = this.$refs.homeCont;
      let loader = this.$loading.show({
        container: homeCont,
        loader: "Dots",
        color: "red",
        opacity: 0.5,
        backgroundColor: "#000000",
      });
      HTTP.get(`game/betflix/get-provider`)
        .then((resp) => {
          this.$store.dispatch("saveProviders", resp.data.providers);
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        })
        .then(() => {
          loader.hide();
        });
    },
    fetchUserProfile() {
      let cur_credit =
        this.Auth.count != null ? parseFloat(this.Auth.count) : "";
      HTTP.get(`member/profile`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
            );
          } else {
            if (resp.data.status != undefined && resp.data.status) {
              let new_credit = parseInt(resp.data.data.count);
              if (new_credit > cur_credit && cur_credit != "") {
                // let new_credit = resp.data.data.balance - cur_credit;
                this.$swal.fire({
                  title:
                    "ฝากเครดิตจำนวน " +
                    parseFloat(resp.data.data.amount) +
                    " บาท สำเร็จ!",
                  icon: "success",
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: "ตกลง",
                });
              }
              this.$store.dispatch("saveProfile", resp.data.data);
            }
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาเข้าสู่ระบบใหม่อีกครั้ง"
          );
        });
    },
    fetchTurnover() {
      HTTP.get(`member/turnover`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลเทิร์นโอเวอร์ได้ กรุณาลองใหม่"
            );
          } else {
            this.$store.dispatch("saveTurnover", resp.data.turnover);
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลเทิร์นโอเวอร์ได้ กรุณาลองใหม่"
          );
        });
    },
    fetchNotify() {
      HTTP.get(`member/notification`)
        .then((resp) => {
          // if (resp.data.status != undefined && !resp.data.status) {
          //   this.$toast.error(
          //     resp.data.msg != undefined
          //       ? resp.data.msg
          //       : "ไม่สามารถโหลดข้อมูลเทิร์นโอเวอร์ได้ กรุณาลองใหม่"
          //   );
          // } else {
          //   this.$store.dispatch("saveTurnover", resp.data.turnover);
          // }
          console.log(resp);
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลเทิร์นโอเวอร์ได้ กรุณาลองใหม่"
          );
        });
    },
    fetchWebSetting() {
      HTTP.get(`system/info`)
        .then((resp) => {
          if (resp.data.status === true) 
          {
            this.$store.dispatch("savePageSetting", resp.data.data);
            this.mq_text = resp.data.data.website_annoucetext;
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
          );
        });
    },
    intervalfetchTurnover() {
      this.intervalTurnover = setInterval(() => {
        this.fetchTurnover();
      }, 30000);
    },
    intervalfetchUserProfile() {
      this.intervalProfile = setInterval(() => {
        this.fetchUserProfile();
      }, 10000);
    },
    mouseOver: function(){
      this.isMarqueePause = true;   
    },
    mouseLeave: function(){
      this.isMarqueePause = false;   
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalTurnover);
    clearInterval(this.intervalProfile);
  },
  computed: {
    ...mapGetters(["Auth"]),
    ...mapGetters(["WebSetting"]),
  },
};
</script>
